import './Embed.scss'
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { teamStore, channelStore } from '../../app/stores'

class Embed extends Component {
  render () {
    const { channel } = channelStore
    if (!channel) return null
    return (
      <div className='Embed'>
        <textarea
          value={`<script src="https://embed.small.chat/${teamStore.teamId}${channelStore.channelId}.js" async></script>`}
          readOnly
          rows={2}
        />
        <p>Copy and paste this script into your site's index.html file. For more detailed instructions see <a href="https://docs.small.chat/installation">https://docs.small.chat/installation</a>.</p>
      </div>
    )
  }
}

Embed.displayName = 'Embed'

export default observer(Embed)



// WEBPACK FOOTER //
// ./src/channel/embed/Embed.js